import React, { useEffect, useState } from "react";
import { logResponse } from "../utils/logger";
import { useSearchParams, useNavigate } from "react-router-dom";
import { fetchChangeEmail } from "../api";

const ChangeEmailForm = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [message, setMessage] = useState("メールアドレスの変更を確認しています...");
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    const token = searchParams.get("token");
    const access_token = localStorage.getItem("access_token");

    // 5秒後にトップページへ遷移（どんな結果でも）
    const timer = setTimeout(() => {
      navigate("/");
    }, 5000);

    if (!token) {
      setMessage("トークンが見つかりません。URLをご確認ください。");
      setStatus("error");
      return () => clearTimeout(timer);
    }

    if (!access_token) {
      setMessage("アクセストークンが見つかりません。ログイン状態をご確認ください。");
      setStatus("error");
      return () => clearTimeout(timer);
    }

    const data = { token };

    fetchChangeEmail(access_token, data)
      .then((res) => {
        logResponse("token:", access_token);
        logResponse("req:", data);
        logResponse("res:", res);
        if (res?.email) {
          setMessage(`メールアドレスの変更が完了しました：${res.email}`);
          setStatus("success");
        } else if (res?.detail === "token not found (revoked?)") {
          setMessage(
            "メールアドレスの変更に失敗しました。リンクが無効か、すでに使用済みの可能性があります。再度変更リクエストをお試しください。"
          );
          setStatus("error");
        } else if (res?.detail) {
          setMessage(`変更に失敗しました：${res.detail}`);
          setStatus("error");
        } else {
          setMessage("メールアドレスの変更に失敗しました。リンクが無効か期限切れの可能性があります。");
          setStatus("error");
        }
      })
      .catch((err) => {
        console.error("API呼び出しエラー:", err);
        setMessage("通信エラーが発生しました。時間を置いて再度お試しください。");
        setStatus("error");
      });

    // クリーンアップ
    return () => clearTimeout(timer);
  }, [searchParams, navigate]);

  return (
    <section className="section change-email-section">
      <h2 className="section-title">メールアドレス変更</h2>
      <div className="group-wrapper">
        <div className={`message-box ${status}`}>
          <p>{message}</p>
          <p style={{ fontSize: "0.9em", marginTop: "0.5em", color: "#666" }}>
            5秒後にトップページへ移動します...
          </p>
        </div>
      </div>
    </section>
  );
};

export default ChangeEmailForm;
